import { useMutation } from "@apollo/client";
import { Form as AntForm } from "antd";
import { motion } from "framer-motion";
import React, { useState } from "react";
import { GoogleLogin } from "react-google-login";
import { AiFillPhone } from "react-icons/ai";
import { IoFlagSharp } from "react-icons/io5";
import { MdEmail, MdLock } from "react-icons/md";
import { useHistory, useLocation } from "react-router-dom";
import countryList from "react-select-country-list";
import {
  authComponentTransition,
  authPageTransition,
} from "../../animation/index";
import {
  CHECK_GOOGLE_AUTH,
  FORGOT_PASSWORD,
  GOOGLE_AUTH,
  LOGIN,
  RESET_PASSWORD,
} from "../../app/apollo/index";
import facebook from "../../assets/facebook.png";
import google from "../../assets/google.png";
import twitter from "../../assets/twitter.png";
import { AuthenticationLayout } from "../../globalComponents/AuthenticationLayout";
import { DropDown } from "../../globalComponents/DropDown";
import { Label } from "../../globalComponents/globalStyle";
import {
  LoggerButton,
  PasswordInput,
  TextInput,
} from "../../globalComponents/Index";
import { ModalComponent } from "../../globalComponents/Modal";
import withoutAuth from "../../HOC/withoutAuth";
import { NotificationAlert } from "../../utils/NotificationAlert";
import { InputDiv, StyledInput } from "../Register/style";
import { Account, Mutetext, NotificationText, SocialContainer } from "./style";

interface Logintype {
  email: string;
  password: string;
}

const Login: React.FC = () => {
  const options = React.useMemo(() => countryList().getData(), []);

  const [forgotLoading, setForgotLoading] = useState(false);
  const [resetLoading, setResetLoading] = useState(false);

  const [current, setCurrent] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [value, setValue] = useState();
  const [gUpdateLoading, setGUpdateLoading] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const [accessToken, setAccessToken] = useState();
  const [loading, setLoading] = React.useState(false);
  const [login] = useMutation(LOGIN);
  const [forgotPassword] = useMutation(FORGOT_PASSWORD);
  const [verifyUserViaGoogleToken] = useMutation(CHECK_GOOGLE_AUTH);
  const [googleAuth] = useMutation(GOOGLE_AUTH);
  const [resetPassword] = useMutation(RESET_PASSWORD);

  const history = useHistory();
  const handleForgotPassword = async (values: any) => {
    setValue(values.email);
    setForgotLoading(true);
    try {
      const response = await forgotPassword({
        variables: {
          email: values.email.toLowerCase().trim(),
        },
      });
      if (response) {
        setForgotLoading(false);
        console.log(response);
        if (response?.data?.forgotPassword?.success) {
          setCurrent(1);
          NotificationAlert(
            "success",
            "Success",
            response?.data?.forgotPassword?.msg
          );
        } else {
          NotificationAlert(
            "error",
            "Error",
            response?.data?.forgotPassword?.msg
          );
        }
      }
    } catch (e) {
      console.log(e);
      setForgotLoading(false);
      NotificationAlert("error", "Error", "Try again later");
    }
  };
  const handleResetPasswrod = async (values: any) => {
    setResetLoading(true);
    try {
      const response = await resetPassword({
        variables: {
          email: value,
          resetToken: values.resetToken,
          newPassword: values.newPassword,
        },
      });
      if (response) {
        setResetLoading(false);

        if (response?.data?.resetPassword?.success) {
          setOpenModal(false);
          setCurrent(0);
          NotificationAlert(
            "success",
            "Success",
            response?.data?.resetPassword?.msg
          );
        } else {
          NotificationAlert(
            "error",
            "Error",
            response?.data?.resetPassword?.msg
          );
        }
      }
    } catch (e) {
      setResetLoading(false);
      console.log(e);
      NotificationAlert("error", "Error", "Try again later");
    }
  };
  const location = useLocation();

  const googleFail = (response: any) => {
    console.log("google", response);
    // NotificationAlert(
    //   "error",
    //   "Error Occured",
    //   "Could not login. Try Again Later"
    // );
  };
  const googleLogin = async (values: any) => {
    const { accessToken, profileObj } = values;
    console.log("");
    setLoading(true);
    setAccessToken(accessToken);
    console.log("acessToken", accessToken);
    console.log("profileObj", profileObj);
    try {
      const googleVerifyResponse: any = await verifyUserViaGoogleToken({
        variables: {
          token: accessToken,
        },
      });
      console.log("google verification response", googleVerifyResponse);
      if (googleVerifyResponse) {
        setLoading(false);
        if (
          googleVerifyResponse?.data?.verifyUserViaGoogleToken?.msg ===
          "User profile has not been created"
        ) {
          setUpdateModal(true);
        } else if (
          googleVerifyResponse?.data?.verifyUserViaGoogleToken?.msg ===
          "user logged in"
        ) {
          localStorage.setItem(
            "token",
            googleVerifyResponse?.data?.verifyUserViaGoogleToken?.access_token
          );
          if (
            googleVerifyResponse?.data?.verifyUserViaGoogleToken?.user
              ?.seenOnboard === false
          ) {
            history.replace("/onboard");
          } else {
            if (
              googleVerifyResponse?.data?.verifyUserViaGoogleToken?.user
                ?.defaultDestination === null
            ) {
              history.replace("/destination");
            } else {
              history.replace("/home");
            }
          }
        }
      }
    } catch (e) {
      NotificationAlert("error", "Error Occured");
      setLoading(false);
    }
  };

  const googleUpdate = async (values: any) => {
    setGUpdateLoading(true);
    console.log("values from google update", values);
    const allValues = { ...values, token: accessToken };
    console.log("all values", allValues);
    try {
      const response = await googleAuth({
        variables: {
          ...allValues,
        },
      });
      if (response) {
        setGUpdateLoading(false);
        if (response?.data?.googleAuth?.success) {
          localStorage.setItem(
            "token",
            response?.data?.googleAuth?.access_token
          );
          if (response?.data?.googleAuth?.user?.seenOnboard === false) {
            history.replace("/onboard");
          } else {
            if (response?.data?.googleAuth?.user?.defaultDestination === null) {
              history.replace("/destination");
            } else {
              history.replace("/home");
            }
          }
        } else {
          NotificationAlert("error", "Error", response?.data?.googleAuth?.msg);
        }
      }
    } catch (e) {
      setGUpdateLoading(false);
      NotificationAlert(
        "error",
        "Error occured",
        "Try Again, could not update user"
      );
    }
  };

  const onFinish = async (values: Logintype) => {
    console.log(values);
    setLoading(true);
    // console.log("screen width", window.screen.width);
    try {
      const response: any = await login({
        variables: {
          email: values.email.toLowerCase().trim(),
          password: values.password.toLowerCase().trim(),
        },
      });
      if (response) {
        setLoading(false);
        if (response?.data?.login?.success) {
          localStorage.setItem("token", response?.data?.login?.access_token);
          if (response?.data?.login?.user?.seenOnboard === false) {
            history.replace("/onboard");
          } else {
            if (response?.data?.login?.user?.defaultDestination === null) {
              history.replace("/destination");
            } else {
              history.replace("/home");
            }
          }
        } else {
          NotificationAlert("error", "Error", response?.data?.login?.msg);
        }
      }
      console.log("the response is", response);
    } catch (e: any) {
      NotificationAlert("error", "Error", "Try again later");

      setLoading(false);
      console.log(e.message);
    }
  };
  const onFinishFailed = (errorInfo: any) => {
    console.log(errorInfo);
  };
  return (
    <AuthenticationLayout>
      <motion.div
        variants={authPageTransition}
        transition={authComponentTransition}
        exit="out"
        animate="in"
        initial="initial"
      >
        <ModalComponent
          visible={updateModal}
          onCancel={() => setUpdateModal(false)}
        >
          <div style={{ padding: "1vw", width: "100%" }}>
            <NotificationText>Update Information</NotificationText>
            <AntForm layout="vertical" onFinish={googleUpdate}>
              <AntForm.Item
                name="password"
                rules={[
                  {
                    required: true,
                    message: "field is required",
                  },
                  { min: 8, message: "must contain at least 8 characters" },
                ]}
                label={
                  <Label>
                    <div>
                      <MdLock />
                    </div>{" "}
                    <h3>Password</h3>
                  </Label>
                }
              >
                <div>
                  <PasswordInput
                    required={true}
                    type="text"
                    placeholder="Enter password"
                    name="password"
                  />
                </div>
              </AntForm.Item>
              <AntForm.Item
                name="phone"
                rules={[
                  {
                    required: true,
                    message: "field is required",
                  },
                ]}
                label={
                  <Label>
                    <div className="active">
                      <AiFillPhone />
                    </div>{" "}
                    <h3>Phone Number</h3>
                  </Label>
                }
              >
                <InputDiv>
                  <StyledInput
                    inputClass="inputStyle"
                    containerClass="containerStyle"
                    dropdownClass="dropdownStyle"
                    buttonClass="buttonStyle"
                    searchClass="searchStyle"
                    country={"us"}
                    // onChange={(e, c) => setCountry(c)}
                  />
                </InputDiv>
              </AntForm.Item>

              <AntForm.Item
                name="homeCountry"
                rules={[
                  {
                    required: true,
                    message: "field is required",
                  },
                ]}
                label={
                  <Label>
                    <div className="active">
                      <IoFlagSharp />
                    </div>{" "}
                    <h3>Home Country</h3>
                  </Label>
                }
              >
                <div>
                  <DropDown
                    required={true}
                    placeholder="Select a Country"
                    values={options}
                    // onChange={changeHandler}
                  />
                </div>
              </AntForm.Item>
              <LoggerButton
                loading={gUpdateLoading}
                width="50%"
                htmlType="submit"
                text="Login"
              />
            </AntForm>
          </div>
        </ModalComponent>
        <ModalComponent
          visible={openModal}
          onCancel={() => {
            setOpenModal(false);
            setCurrent(0);
          }}
        >
          <div style={{ padding: "1vw", width: "100%" }}>
            {current === 0 ? (
              <>
                {" "}
                <NotificationText>Reset Password</NotificationText>
                <AntForm layout="vertical" onFinish={handleForgotPassword}>
                  <AntForm.Item
                    name="email"
                    label={
                      <Label>
                        <h3>Email</h3>
                      </Label>
                    }
                  >
                    <div>
                      <TextInput
                        required={true}
                        type="email"
                        placeholder="Enter email"
                      />
                    </div>
                  </AntForm.Item>
                  <LoggerButton
                    loading={forgotLoading}
                    width="50%"
                    htmlType="submit"
                    text="Reset"
                  />
                </AntForm>
              </>
            ) : (
              <>
                <NotificationText>
                  {" "}
                  A reset token has been sent to <span>{value}</span>.
                </NotificationText>
                <br />
                <AntForm layout="vertical" onFinish={handleResetPasswrod}>
                  <AntForm.Item
                    name="resetToken"
                    label={
                      <Label>
                        <h3>Reset Token</h3>
                      </Label>
                    }
                  >
                    <div>
                      <TextInput
                        required={true}
                        type="text"
                        placeholder="Enter reset token"
                      />
                    </div>
                  </AntForm.Item>
                  <AntForm.Item
                    rules={[
                      { min: 8, message: "must contain at least 8 characters" },
                    ]}
                    label={
                      <Label>
                        <h3>New Password</h3>
                      </Label>
                    }
                    name="newPassword"
                  >
                    <div>
                      <PasswordInput
                        required={true}
                        type="text"
                        placeholder="Enter new password"
                      />
                    </div>
                  </AntForm.Item>
                  <LoggerButton
                    loading={resetLoading}
                    width="50%"
                    htmlType="submit"
                    text="Reset"
                  />
                </AntForm>
              </>
            )}
          </div>
        </ModalComponent>
        <h3>LOGIN</h3>
        <AntForm
          layout="vertical"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <AntForm.Item
            name="email"
            label={
              <Label>
                <div className="active">
                  <MdEmail />
                </div>{" "}
                <h3>Email Address</h3>
              </Label>
            }
          >
            <div>
              <TextInput
                required={true}
                type="email"
                placeholder="Enter email"
                name="email"
              />
            </div>
          </AntForm.Item>

          <AntForm.Item
            name="password"
            label={
              <Label>
                <div>
                  <MdLock />
                </div>{" "}
                <h3>Password</h3>
              </Label>
            }
          >
            <div>
              <PasswordInput
                required={true}
                type="email"
                placeholder="Enter password"
                name="email"
              />
            </div>
          </AntForm.Item>
          <Mutetext onClick={() => setOpenModal(true)}>
            Forgot Password
          </Mutetext>
          <LoggerButton
            loading={loading}
            width="80%"
            htmlType="submit"
            text="Login"
          />
        </AntForm>
        <Account>
          Don't have an account?{" "}
          <span onClick={() => history.push("/sign-up")}>Signup here</span>
        </Account>

        <Mutetext style={{ textAlign: "center" }}>Or</Mutetext>
        <Mutetext style={{ textAlign: "center" }}>
          Continue with social media
        </Mutetext>
        <SocialContainer>
          <div>
            <img src={facebook} alt="facebook-sign-in" />
          </div>
          <div>
            <GoogleLogin
              clientId="1090991213442-nr5b29thhftc0i5bq516gn954ahe5a2p.apps.googleusercontent.com"
              render={(renderProps) => (
                // <div>
                <img
                  onClick={renderProps.onClick}
                  src={google}
                  alt="google-sign-in"
                />
                // </div>
              )}
              buttonText="Login"
              onFailure={googleFail}
              onSuccess={googleLogin}
              cookiePolicy={"single_host_origin"}
            />
          </div>
          {/* <div>
            <img src={google} alt="google-sign-in" />
          </div> */}
          <div>
            <img src={twitter} alt="twitter-sign-in" />
          </div>
        </SocialContainer>
      </motion.div>
    </AuthenticationLayout>
  );
};

export default withoutAuth(Login);
